import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SubscriptionPriceService } from 'src/app/services/subscription-price.service';
import { FieldConfig } from '../field.interface';

@Component({
  selector: 'calsoft-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss']
})
export class MultiSelectComponent implements OnInit, OnChanges {

  @Input() field!: FieldConfig;
  @Input() group!: UntypedFormGroup;
  @Output() valueChange = new EventEmitter<any>();
  @Output() selectedValueChange = new EventEmitter<any>();

  optionsList: string[] = [];
  vendorIds: string[] = [];

  localFormControl = new FormControl<string[]>([]);

  constructor(
    private subscriptionService: SubscriptionPriceService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.initializeOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.field && changes.field.currentValue) {
      this.initializeOptions();
    }
  }

private initializeOptions(): void {

  // OPTIONS (vendor names)
  if (Array.isArray(this.field.options)) {
    this.optionsList = this.field.options;
  } else if (typeof this.field.options === 'string') {
    this.optionsList = this.field.options.split(',').map(o => o.trim());
  } else {
    this.optionsList = [];
  }

  // IDS (vendor ids)
  if (Array.isArray(this.field.customField8)) {
    this.vendorIds = this.field.customField8;
  } else if (typeof this.field.customField8 === 'string') {
    this.vendorIds = this.field.customField8.split(',').map(id => id.trim());
  } else {
    this.vendorIds = [];
  }

  this.localFormControl.setValue([]);
}


  isRequired(fieldName: string): boolean {
    const control = this.group.get(fieldName);
    return !!(control && control.hasError('required'));
  }

  // 🔥 CORE LOGIC: map vendor names → vendor IDs
  onVendorSelectionChange(selectedVendors: string[]): void {
    const selectedIds = this.mapVendorNamesToIds(selectedVendors);

    const control = this.group.get(this.field.name);
    if (control) {
      control.setValue(selectedIds); // push IDs to form
    }

    this.valueChange.emit(this.field.name);
    this.selectedValueChange.emit(selectedIds);

    console.log('Selected Vendors:', selectedVendors);
    console.log('Selected Vendor IDs:', selectedIds);
  }

  private mapVendorNamesToIds(selectedVendors: string[]): string[] {
    return selectedVendors
      .map(vendor => {
        const index = this.optionsList.indexOf(vendor);
        return index !== -1 ? this.vendorIds[index] : null;
      })
      .filter((id): id is string => id !== null);
  }
}
